import { render } from "./Scalepriceeditor.vue?vue&type=template&id=14962f88&scoped=true"
import script from "./Scalepriceeditor.vue?vue&type=script&lang=js"
export * from "./Scalepriceeditor.vue?vue&type=script&lang=js"

import "./Scalepriceeditor.vue?vue&type=style&index=0&id=14962f88&scoped=true&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14962f88"]])

export default __exports__